export default __webpack_public_path__ + "static/media/progress.dd603277.svg";